import { Component } from "@angular/core";

import { OnInit } from "@angular/core";

import clonedeep from "lodash.clonedeep";

import { MedicineService } from "../../services/medicine.services";
import { LocationsDialogComponent } from "../locations-dialog/locations-dialog.component";
import { MatDialog } from "@angular/material";
import { IncidentsDialogComponent } from "../incidents-dialog/incidents-dialog.component";
import { BatchDialogComponent } from "../batch-dialog/batch-dialog.component";
import { ExpiryReportDialogComponent } from "../expiry-report-dialog/expiry-report-dialog.component";
import { RecallReportDialogComponent } from "../recall-report-dialog/recall-report-dialog.component";
import { GlobalCfgService } from '../../services/globalcfg.service';
import { AccessDeniedDialogComponent } from '../access-denied-dialog/access-denied-dialog.component';
import { EventBusService } from 'src/services/event-bus.service';

@Component({
  selector: "rm-products-list",
  templateUrl: "./products-list.component.html",
  styleUrls: ["./products-list.component.css"]
})
export class ProductsListComponent implements OnInit {
  products = [];
  refProducts = [];
  gcp: any;
  searchTxt: string = "";

  //Used for pagination
  bookmark: string = "";
  totalCount: number = 0;
  pageSize: number = 10;
  skip: number = 0;
  bookmarks: any[] = [];

  loaded: boolean = false;
  labels: any;
  subscriptions: any[] = [];

  constructor(
    private dialog: MatDialog,
    private medicineService: MedicineService,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService
  ) { }

  ngOnInit() {
    this.loadProducts();

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.loadProducts();
      }
    ));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadProducts(page?) {
    this.gcp = this.globalCfgService.getGcp();
    this.labels = this.globalCfgService.getSettingValue('labels');

    var obj = {};

    if (this.gcp) {
      obj['gcp'] = this.gcp;
    }

    obj['pageSize'] = (page && page.pageSize) || this.pageSize;

    if (page) {
      this.skip = page.pageIndex * this.pageSize;
      obj['skip'] = this.skip;
    } else if (page === undefined) {
      obj['skip'] = this.skip;
    }

    this.medicineService.details(obj).subscribe(response => {

      if (page && page.pageIndex) {
        this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
      } else {
        this.bookmarks[1] = response['metadata'].bookmark;
      }
      this.totalCount = response['metadata'].totalCount;

      this.products = Object(response['result']);
      this.refProducts = clonedeep(this.products);

      this.loaded = true;
    });
  }

  loadProductsByName(searchTxt) {
    this.products = this.refProducts.filter(element => {
      if (element.name.toLowerCase().indexOf(searchTxt.toLowerCase()) > -1) {
        return element;
      }
    });
  }

  applyFilter() {
    if (this.searchTxt.length == 0) {
      this.skip = 0;
      this.loadProducts();
    } else {
      this.loadProductsByName(this.searchTxt);
    }
  }

  clear() {
    this.searchTxt = "";
    this.loadProducts();
  }

  showLocations(id) {
    this.dialog.open(LocationsDialogComponent, {
      width: "2400px",
      data: { productId: id, gcp: this.globalCfgService.getGcp() }
    });
  }

  showDistribution(id) {
    this.dialog.open(IncidentsDialogComponent, {
      width: "2400px",
      data: { productId: id, gcp: this.globalCfgService.getGcp() }
    });
  }

  showBatches(id) {
    // debugger;

    var hasAccess = this.globalCfgService.getAclValueFor('manage-batch');

    if (!hasAccess) {
      this.dialog.open(AccessDeniedDialogComponent, {
        width: "450px"
      });
    } else {
      this.dialog.open(BatchDialogComponent, {
        width: "2400px",
        data: { productId: id, gcp: this.globalCfgService.getGcp() }
      });
    }
  }

  showExpiryReport(id) {
    var hasAccess = this.globalCfgService.getAclValueFor('expiry-report');

    if (!hasAccess) {
      this.dialog.open(AccessDeniedDialogComponent, {
        width: "450px"
      });
    } else {
      this.dialog.open(ExpiryReportDialogComponent, {
        width: "2400px",
        data: { productId: id, gcp: this.globalCfgService.getGcp() }
      });
    }
  }

  showRecallReport(id) {
    var hasAccess = this.globalCfgService.getAclValueFor('recall-report');

    if (!hasAccess) {
      this.dialog.open(AccessDeniedDialogComponent, {
        width: "450px"
      });
    } else {
      this.dialog.open(RecallReportDialogComponent, {
        width: "2400px",
        data: { productId: id, gcp: this.globalCfgService.getGcp() }
      });
    }
  }

  onPageChange(page) {
    this.pageSize = page.pageSize;
    this.loadProducts(page);
  }
}
